import React from 'react';
import { POSTURE_THEME } from './lib/theme';

interface GridOverlayProps {
  type?: '3x3' | 'golden' | 'center' | 'none';
  opacity?: number;
}

// Golden ratio ≈ 0.618
const GOLDEN_RATIO = 0.618;

const GridOverlay: React.FC<GridOverlayProps> = ({ type = '3x3', opacity = 0.4 }) => {
  if (type === 'none') return null;

  return (
    <div className="absolute inset-0 pointer-events-none" style={{ opacity }}>
      {/* Border Frame */}
      <div className={`absolute inset-4 border-2 ${POSTURE_THEME.colors.neutral.border} opacity-50 rounded-sm`} />
      
      {/* Center Crosshair - always shown */}
      <div className="absolute top-1/2 left-0 w-full h-px bg-cyan-400/50 transform -translate-y-1/2" />
      <div className="absolute left-1/2 top-0 w-px h-full bg-cyan-400/50 transform -translate-x-1/2" />

      {/* 3x3 Grid (Rule of Thirds) */}
      {type === '3x3' && (
        <>
          <div className="absolute top-1/3 left-0 w-full h-px bg-background/30" />
          <div className="absolute top-2/3 left-0 w-full h-px bg-background/30" />
          <div className="absolute left-1/3 top-0 w-px h-full bg-background/30" />
          <div className="absolute left-2/3 top-0 w-px h-full bg-background/30" />
        </>
      )}

      {/* Golden Ratio Grid */}
      {type === 'golden' && (
        <>
          {/* Horizontal lines at golden ratio positions */}
          <div 
            className="absolute left-0 w-full h-px bg-warning text-warning-foreground/40" 
            style={{ top: `${GOLDEN_RATIO * 100}%` }} 
          />
          <div 
            className="absolute left-0 w-full h-px bg-warning text-warning-foreground/40" 
            style={{ top: `${(1 - GOLDEN_RATIO) * 100}%` }} 
          />
          {/* Vertical lines at golden ratio positions */}
          <div 
            className="absolute top-0 w-px h-full bg-warning text-warning-foreground/40" 
            style={{ left: `${GOLDEN_RATIO * 100}%` }} 
          />
          <div 
            className="absolute top-0 w-px h-full bg-warning text-warning-foreground/40" 
            style={{ left: `${(1 - GOLDEN_RATIO) * 100}%` }} 
          />
        </>
      )}

      {/* Center-only mode - just shows the crosshairs which are always rendered above */}
      {type === 'center' && (
        <>
          {/* Additional center target circles */}
          <div className="absolute top-1/2 left-1/2 w-16 h-16 border border-cyan-400/30 rounded-full transform -translate-x-1/2 -translate-y-1/2" />
          <div className="absolute top-1/2 left-1/2 w-32 h-32 border border-cyan-400/20 rounded-full transform -translate-x-1/2 -translate-y-1/2" />
        </>
      )}
    </div>
  );
};

export default GridOverlay;

